export const API_URL = process.env.REACT_APP_BASE_URL;
export const SESSION_NAME = process.env.REACT_APP_SESSION_NAME;
export const SESSION_KEY = process.env.REACT_APP_SESSION_KEY;
export const TOKEN_KEY = process.env.REACT_APP_TOKEN_KEY;
export const TOKEN_NAME = process.env.REACT_APP_TOKEN_NAME;
export const ADMIN_ROLE_ID = process.env.REACT_APP_ADMIN_ROLE_ID;
